import { setLoginStatus } from './auth';

export const initApp = () => dispatch => {
  dispatch(setLoginStatus());
};

export default {};
